define('bizzabo/bzapi',[
    'bizzabo/config',
    'bizzabo/utils',
    'jquery',
    'axios',
    'jquery-cookie',
    'easyXDM',
    'underscore'
], function(
        CONFIG,
        UTILS,
        $,
        axios,
        jqueryCookie,
        easyXDM,
        _
    ) {

    var BZAPI = (function() {

        // Config ----------------------------------------

        var BASEAPI = "/api/v1/";
        var LOCAL_EASYXDM = "../easyXDM/";
        var REMOTE_EASYXDM = CONFIG.SERVER_URL + "/static/scripts/easyXDM/";
        var DEFAULT_TIMEOUT = 60 * 1000;

        // Easy XDM bootstrap

        var xhr = new easyXDM.Rpc({
            local : LOCAL_EASYXDM + "name.html",
            swf : REMOTE_EASYXDM + "easyxdm.swf",
            remote : REMOTE_EASYXDM + "cors/",
            remoteHelper : REMOTE_EASYXDM + "name.html"
        }, {
            remote : {
                request : {}
            }
        });

        // Bizzabo Error Codes ----------------------------------------

        var errorCodes = {
            General : 0,
            RequestCancelled : 1,
            MissingContent : 4001, // Not all required content for the API call was supplied
            APIVersion : 4002, // The API version reported by the client is no longer supported
            SourceIsAlreadyTaken : 4006, // The event [source]+[source-id] are already taken by another event
            NoSuchUser : 4010, // Unknown user tried to sign in
            InvalidTokens : 4011, // The access tokens are invalid (or missing)
            EmailNotValidated : 4012, // The user did not validate his email address yet
            NotAuthorized : 4013, // The user is not authorized to make this request
            NeedAdditionalAuth : 4014, // Resource requires additional authorization
            NotOrganizer : 4030, // Attempt to get an organizer Event by a Person that is not the organizer
            EntityDoesNotExist : 4040, // Attempt to read an Entity with a non-existent ID
            EntityExists : 4090, // Entity exist
            UserExists : 4091, // Existing user tried to sign up again
            EmailExists : 4092, // The email used for sign up is already in use by another user
            TargetNotInRSVP : 4094, // The other person is not RSVPd
            NoSpotsLeft : 4096, // The offer has no spots left
            OfferExpired : 4097, // The offer has expired
            ServerError : 5000, // Unspecified server error
            NotImplementedError : 5010,  // This API is not implemented yet
        };

        // Bizzabo Access Token ----------------------------------------

        var getRootDomain = function() {
            var components = CONFIG.WEBORGANIZER_URL.split('//');
            var domain = components[1].split('/')[0];
            return encodeURIComponent(domain);
        };

        var setBzToken = function(token) {
            // Cookie must be set for file uploads (no way to append auth headers)
            return $.cookie(CONFIG.AUTH_COOKIE_NAME, token, {
                expires : 3650,
                secure : true,
                domain : getRootDomain(),
                path : '/'
            });
        };

        var getTokenFromHeaders = function(headers) {
            var token = headers['x-bz-access-token'] || headers['X-Bz-Access-Token'];
            token = token.replace('\r', '');
            return token;
        };

        var removeBzToken = function(token) {
            $.cookie(CONFIG.AUTH_COOKIE_NAME, null);
            $.cookie(CONFIG.AUTH_COOKIE_NAME, null, {
                secure : true,
                domain : getRootDomain(),
                path : '/'
            });
        };

        var bzToken = function() {
            return $.cookie(CONFIG.AUTH_COOKIE_NAME);
        };

        var hasToken = function() {
            return (bzToken() != null);
        };

        var extendBzToken = function() {
            if (hasToken()) {
                setBzToken(bzToken());
            }
        };
        extendBzToken();

        // HTTP Headers

        var headersJSON = {
            "Content-Type" : "application/json",
            "Accept" : "application/json"
        };

        var buildHeaders = function() {
            var headers = headersJSON;
            if (hasToken()) {
                headers.Authorization = 'Bizzabo token="' + bzToken() + '"';
            }
            return headers;
        };

        var genericErrorHandler = function(rpcdata, failureFn) {
            if (_.isFunction(failureFn)) {
                var errorCode, message, status;
                try {
                    var errorData = JSON.parse(rpcdata.data.data);
                    errorCode = errorData.error['error-code'];
                    message = errorData.error.message;
                    status = errorData.error.status;
                } catch (err) {
                    errorCode = 0;
                    message = "";
                    status = 0;
                }
                failureFn(errorCode, message, status);
            }
        };

        var genericSuccessHandler = function(rpcdata, successFn) {
            if (_.isFunction(successFn)) {
                var jsonData = (rpcdata && rpcdata.data && JSON.parse(rpcdata.data)) || {};
                var headers = (rpcdata && rpcdata.headers) || {};
                successFn(jsonData, headers);
            }
        };

        // API methods ----------------------------------------

        var methodPath = function(method, options) {
            var path = options.path;
            var data = options.data;
            var headers = _.extend(buildHeaders(), options.headers);
            var timeout = options.timeout || DEFAULT_TIMEOUT;
            var successFn = options.success;
            var failureFn = options.failure;

            xhr.request({
                url : BASEAPI + path,
                method : method,
                headers : headers,
                data : data,
                timeout : timeout
            }, function(rpcdata) {
                genericSuccessHandler(rpcdata, successFn);
            }, function(rpcdata) {
                genericErrorHandler(rpcdata, failureFn);
            });
        };

        var getPath = function(options) {
            options.data = options.data || {};
            options.data._nocache = new Date().getTime();
            methodPath("GET", options);
        };

        var putPath = function(options) {
            methodPath("PUT", options);
        };

        var postPath = function(options) {
            methodPath("POST", options);
        };

        var deletePath = function(options) {
            methodPath("DELETE", options);
        };

        // Sign in ----------------------------------------

        var signIn = function(key, memberID, signature, successFn, failureFn) {
            postPath({
                path : "auth/access-token",
                headers : {
                    Authorization : 'Bizzabo provider="linkedin-js", key="' + key + '", member_id="' + memberID + '", signature="' + signature + '"'
                },
                timeout : 30 * 1000,
                success : function(jsonData, headers) {
                    setBzToken(getTokenFromHeaders(headers));
                    _.isFunction(successFn) && successFn(jsonData);
                },
                failure : failureFn
            });
        };

        var signUp = function(key, memberID, signature, personData, successFn, failureFn) {
            postPath({
                path : "person",
                headers : {
                    Authorization : 'Bizzabo provider="linkedin-js", key="' + key + '", member_id="' + memberID + '", signature="' + signature + '"'
                },
                data : {
                    person : personData
                },
                success : function(jsonData, headers) {
                    setBzToken(getTokenFromHeaders(headers));
                    _.isFunction(successFn) && successFn(jsonData);
                },
                failure : failureFn
            });
        };

        var signOut = function() {
            removeBzToken();
        };

        // Person ----------------------------------------

        var getPerson = function(personID, successFn, failureFn) {
            getPath({
                path : "person/" + personID,
                success : function(jsonData) {
                    _.isFunction(successFn) && successFn(jsonData.person);
                },
                failure : failureFn
            });
        };

        var updatePerson = function(personInfo, successFn, failureFn) {
            putPath({
                path : "person/~",
                data : {
                    person : personInfo
                },
                success : successFn,
                failure : failureFn
            });
        };

        var updateToken = function(provider, key, secret, successFn, failureFn) {
            var data = {
                token : {
                    key : key,
                    provider : provider
                }
            };
            if (secret) {
                data.token.secret = secret
            }
            putPath({
                path : "person/~/tokens",
                data : data,
                success : successFn,
                failure : failureFn
            });
        };

        // Event ----------------------------------------

        var getEventDetails = function(eventId, successFn, failureFn) {
            getPath({
                path : "organizer/event/" + eventId,
                success : function(jsonData) {
                    _.isFunction(successFn) && successFn(jsonData.event);
                },
                failure : failureFn
            });
        };

        var getEventAnalytics = function(eventId, successFn, failureFn) {
            getPath({
                path : "analytics/" + eventId,
                success : function(jsonData) {
                    _.isFunction(successFn) && successFn(jsonData["analytics"]);
                },
                failure : failureFn
            });
        };

        var getMyCreatedEvents = function(successFn, failureFn) {
            getPath({
                path : "organizer/event",
                success : function(jsonData) {
                    _.isFunction(successFn) && successFn(UTILS.ensureArray(jsonData.events.event));
                },
                failure : failureFn
            });
        };

        var importEvents = function(provider, successFn, failureFn) {
            postPath({
                path : "organizer/import/events/" + provider,
                timeout : 60 * 1000,
                success : function(jsonData, headers) {
                    successFn && successFn(UTILS.ensureArray(jsonData['imported-events'].events));
                },
                failure : failureFn
            });
        };

        var createEvent = function(eventInfo, successFn, failureFn) {
            postPath({
                path : "organizer/event/",
                data : {
                    event : eventInfo
                },
                success : function(jsonData, headers) {
                    if (_.isFunction(successFn)) {
                        var location = headers['Location'] || headers['location'];
                        var newLocation = location.replace('\r', '');
                        var components = newLocation.split('/');
                        var eventId = parseInt(components[components.length - 1]);
                        successFn({
                            id : eventId
                        });
                    }
                },
                failure : failureFn
            });
        };

        var updateEventDetails = function(accountId, eventId, eventInfo, successFn, failureFn) {
            putPath({
                path : "accounts/" + accountId + "/events/" + eventId,
                data : eventInfo,
                success : successFn,
                failure : failureFn
            });
        };

        var getEmailList = function(eventId, successFn, failureFn) {
            getPath({
                path : "organizer/event/" + eventId + "/email/status",
                success : function(jsonData) {
                    var list = [];
                    var status = jsonData['email-status'].status;
                    if (_.isObject(status) && status.entry) {
                        list = UTILS.ensureArray(status.entry);
                    }
                    _.isFunction(successFn) && successFn(list);
                },
                failure : failureFn
            });
        };

        var updateEmailList = function(eventId, list, successFn, failureFn) {
            postPath({
                path : "organizer/event/" + eventId + "/email-list",
                data : {
                    emails : {
                        list : list
                    }
                },
                success : successFn,
                failure : failureFn
            });
        };

        var scheduleInviteMailToList = function(eventId, timestamp, successFn, failureFn) {
            postPath({
                path : "organizer/event/" + eventId + "/email",
                data : {
                    'scheduled-email' : {
                        'timestamp' : timestamp
                    }
                },
                timeout : 2 * 60 * 1000,
                success : successFn,
                failure : failureFn
            });
        };

        var deletePersonInEvent = function(eventId, personIds, successFn, failureFn) {
            deletePath({
                path: "organizer/event/"+eventId+"/person/"+personIds,
                success : successFn,
                failure : failureFn
            });
        };

        var sendInviteMailToList = function(eventId, successFn, failureFn) {
            var SEND_NOW_TIMESTAMP = 0;
            scheduleInviteMailToList(eventId, SEND_NOW_TIMESTAMP, successFn, failureFn);
        };

        var sendTestInviteMail = function(eventId, testEmail, successFn, failureFn) {
            postPath({
                path : "organizer/event/" + eventId + "/email/test?email=" + encodeURIComponent(testEmail),
                success : successFn,
                failure : failureFn
            });
        };

        var getInviteMailPreview = function(eventId, successFn, failureFn) {
            getPath({
                path : "organizer/event/" + eventId + "/email/preview",
                success : successFn,
                failure : failureFn
            });
        };

        var publishEvent = function(eventId, successFn, failureFn) {
            postPath({
                path : "organizer/event/" + eventId + "/publish",
                success : successFn,
                failure : failureFn
            });
        };

        // agenda -------------

        var getAgenda = function(eventId, successFn, failureFn) {
            getPath({
                path : "organizer/event/" + eventId + "/agenda",
                success : function(jsonData) {
                    _.isFunction(successFn) && successFn(jsonData.agenda);
                },
                failure : failureFn
            });
        };

        var updateAgenda = function(eventId, agendaJson, successFn, failureFn) {
            putPath({
                path : "organizer/event/" + eventId + "/agenda",
                data : {
                    agenda : agendaJson
                },
                success : function(jsonData) {
                    _.isFunction(successFn) && successFn(jsonData.agenda);
                },
                failure : failureFn
            });
        };

        // service plan -------------

        var getServicePlan = function(id, successFn, failureFn) {
            getPath({
                path : "organizer/packages/account-package/" + id,
                success : function(jsonData) {
                    var servicePlan = jsonData["account-package"];
                    _.isFunction(successFn) && successFn(servicePlan);
                },
                failure : failureFn
            });
        };

        var getFreeServicePlan = function(id, successFn, failureFn) {
            getPath({
                path : "organizer/packages/cart",
                success : function(jsonData) {
                    var servicePlan = jsonData.cart.packages;
                    _.isFunction(successFn) && successFn(servicePlan);
                },
                failure : failureFn
            });
        };

        var getServicePlanByEventID = function(eventId, successFn, failureFn) {
            getPath({
                path : "organizer/event/" + eventId + "/account-package",
                success : function(jsonData) {
                    var servicePlan = jsonData["account-package"];
                    _.isFunction(successFn) && successFn(servicePlan);
                },
                failure : failureFn
            });
        };

        var updateServicePlan = function(id, packageInfo, successFn, failureFn) {
            putPath({
                path : "organizer/packages/account-package/" + id,
                data : {
                    'account-package' : packageInfo
                },
                success : successFn,
                failure : failureFn
            });
        };

        // Misc Actions ----------------------------------------

        var sendMessageToRSVP = function(eventId, message, successFn, failureFn) {
            postPath({
                path : "organizer/event/" + eventId + "/messages/rsvp",
                data : {
                    'message' : {
                        'text' : message
                    }
                },
                timeout : 2 * 60 * 1000,
                success : successFn,
                failure : failureFn
            });
        };

        var getRsvpList = function(eventId, successFn, failureFn) {
            getPath({
                path : "event/" + eventId + "/rsvp",
                success : function(jsonData) {
                    _.isFunction(successFn) && successFn(jsonData.persons);
                },
                failure : failureFn
            });
        };

        // partners (sponsors & exhibitors) -------------

        var partnersSuccess = function(jsonData, successFn) {
            var sponsors = UTILS.ensureArray(jsonData['event-partners']['sponsors']);
            var exhibitors = UTILS.ensureArray(jsonData['event-partners']['exhibitors']);
            var joined = sponsors.concat(exhibitors); // sponsors always first
            _.isFunction(successFn) && successFn(joined);
        };

        var getPartnersList = function(eventId, successFn, failureFn) {
            getPath({
                path : "organizer/event/" + eventId + "/partners",
                success : function(jsonData) {
                    partnersSuccess(jsonData, successFn);
                },
                failure : failureFn
            });
        };

        var updatePartnersList = function(eventId, partnersList, successFn, failureFn) {
            var sponsorsList = [];
            var exhibitorsList = [];
            for (var i in partnersList) {
                var partner = partnersList[i];
                if (partner["partner-type"] == "sponsor") {
                    sponsorsList.push(partner);
                } else {
                    exhibitorsList.push(partner);
                }
            }

            putPath({
                path : "organizer/event/" + eventId + "/partners",
                data : {
                    "event-partners" : {
                        sponsors : sponsorsList,
                        exhibitors : exhibitorsList
                    }
                },
                success : function(jsonData) {
                    partnersSuccess(jsonData, successFn);
                },
                failure : failureFn
            });
        };

        var getPartnersAnalytics = function(eventId, successFn, failureFn) {
            getPath({
                path : "analytics/" + eventId + "/partners",
                success : function(jsonData) {
                    var eventPartnersAnalytics = jsonData["event-partners-analytics"];
                    _.isFunction(successFn) && successFn(UTILS.ensureArray(eventPartnersAnalytics["analytics"]));
                },
                failure : failureFn
            });
        };

        var pollsSuccess = function(jsonData, successFn) {
            var polls = UTILS.ensureArray(jsonData['polls']['poll']);
            _.each(polls, function(poll) {
                poll.questions = UTILS.ensureArray(poll.questions);
                poll['session-ids'] = UTILS.ensureArray(poll['session-ids']);
            });
            _.isFunction(successFn) && successFn(polls);
        };

        var updatePollSuccess = function(jsonData, successFn) {
            var poll = jsonData.poll;
            poll['session-ids'] = UTILS.ensureArray(poll['session-ids']);
            _.isFunction(successFn) && successFn(poll);
        };

        var getPollsList = function(eventId, successFn, failureFn) {
            getPath({
                path : "organizer/event/" + eventId + "/polls",
                success : function(jsonData) {
                    pollsSuccess(jsonData, successFn);
                },
                failure : failureFn
            });
        };

        var updatePollsList = function(eventId, polls, successFn, failureFn) {
            putPath({
                path : "organizer/event/" + eventId + "/polls",
                data : polls,
                success : function(jsonData) {
                    pollsSuccess(jsonData, successFn);
                },
                failure : failureFn
            });
        };

        var updatePoll = function (eventId, poll, successFn, failureFn) {
            putPath({
                path : "organizer/event/" + eventId + "/polls/" + poll.poll.id,
                data : poll,
                success : function(jsonData) {
                    updatePollSuccess(jsonData, successFn);
                },
                failure : failureFn
            });
        };

        var createPoll = function (eventId, poll, successFn, failureFn) {
            postPath({
                path : "organizer/event/" + eventId + "/polls",
                data : poll,
                success : function(jsonData) {
                    updatePollSuccess(jsonData, successFn);
                },
                failure : failureFn
            });
        };

        var clearPollResults = function (pollId, successFn, failureFn) {
            postPath({
                path : "organizer/polls/" + pollId + '/reset',
                success : function(jsonData) {
                    successFn && successFn(jsonData);
                },
                failure : failureFn
            });
        };

        var deletePoll = function (pollId, successFn, failureFn) {
            deletePath({
                path : "organizer/polls/" + pollId,
                success : function(jsonData) {
                    successFn && successFn(jsonData);
                },
                failure : failureFn
            });
        };

        var updatePollsOrder = function(eventId, polls, successFn, failureFn) {
            putPath({
                path : "organizer/event/" + eventId + "/polls-order",
                data : polls,
                success : function(jsonData) {
                    successFn && successFn(jsonData);
                },
                failure : failureFn
            });
        };

        // Social Share ----------------------------------------

        /**
         * Returns: {
	 *	 event-id:
	 *	 person-id:
	 *	 scenario: [rsvp, checkin, linkedin-connect]
	 *	 lat:
	 * 	 long:
	 *   connections: Number of connections in the provider
	 *   provider:
	 * }
         * @param eventId Optional, The event id
         * @param personId Optional, Person id
         * @param providers Optional, array of providers. If not supplied returns all
         * @param successFn Optional, Success callback
         * @param failureFn Optional, Failure callback
         */
        var getSocialShareAnalytics = function(eventId, personId, providers, successFn, failureFn) {
            var data = {};
            if (eventId) {
                data["event-id"] = eventId;
            }
            if (personId) {
                data ["person-id"] = personId;
            }
            if (providers) {
                var arr = UTILS.ensureArray(providers);
                data ["providers"] = arr.length > 1 ? "(" + arr.join() + ")" : providers;
            }

            getPath({
                path : "analytics/social-share",
                data : data,
                success : function(jsonData) {
                    var data = jsonData["social-shares"];
                    _.isFunction(successFn) && successFn(data ? data["social-share"] : []);
                },
                failure : failureFn
            });
        };

        /**
         * Returns: An array of integers, each of which is the sum of impressions in that day/week. Sorted from oldest to newest (newest always being today)
         * @param eventId The event id
         * @param providers Optional, array of providers. If not supplied returns all
         * @param interval Optional, enum: daily | weekly. If not supplied returns a singleton containing today's sum
         * @param successFn Optional, Success callback
         * @param failureFn Optional, Failure callback
         */
        var getSocialShareImpressions = function(eventId, providers, interval, successFn, failureFn) {
            var data = {};
            if (providers) {
                var arr = UTILS.ensureArray(providers);
                data["providers"] = arr.length > 1 ? "(" + arr.join() + ")" : providers;
            }
            if (interval) {
                data["interval"] = interval;
            }

            getPath({
                path : "analytics/" + eventId + "/social-share/impressions",
                data : data,
                success : function(jsonData) {
                    _.isFunction(successFn) && successFn(jsonData.impressions);
                },
                failure : failureFn
            });
        };

        var getTopEntities = function(eventId, type, offset, count, sort, successFn, failureFn) {
            getPath({
                path : "analytics/" + eventId + "/" + type,
                data : {
                    offset : offset,
                    count : count,
                    sort : sort
                },
                success : function(jsonData) {
                    _.isFunction(successFn) && successFn(jsonData.analytics);
                },
                failure : failureFn
            });
        };

        var buildCommunity = function(eventId, successFn, failureFn) {
            putPath({
                path : "organizer/event/" + eventId + "/build-community",
                success : successFn,
                failure : failureFn
            });
        };

        var removeCommunity = function(eventId, successFn, failureFn) {
            putPath({
                path : "organizer/event/" + eventId + "/remove-community",
                success : successFn,
                failure : failureFn
            });
        };

        var replaceImageURL = function(imageURL, successFn, failureFn, type) {
            type = type || 'thumbnail';
            getPath({
                path : 'images/replace',
                data : {
                    url : imageURL,
                    type: type
                },
                timeout : 60 * 1000,
                success : function(jsonData, headers) {
                    if (_.isFunction(successFn)) {
                        var location = headers['Location'] || headers['location'];
                        var newLocation = location.replace('\r', '');
                        successFn(newLocation);
                    }
                },
                failure : failureFn
            });
        };

        var checkUniqueName = function(uniqueName, successFn, failureFn) {
            getPath({
                path : "event/unique-name/" + uniqueName + "/check",
                success : successFn,
                failure : failureFn
            });
        };

        var enablePollingRegistrationSystem = function(eventId, successFn, failureFn) {
            putPath({
                path : "organizer/event/" + eventId + "/registration/add-attendees",
                success : successFn,
                failure : failureFn
            });
        };

        var disablePollingRegistrationSystem = function(eventId, successFn, failureFn) {
            putPath({
                path : "organizer/event/" + eventId + "/registration/remove-attendees",
                success : successFn,
                failure : failureFn
            });
        };

        var getEmailTemplate = function(eventId, successFn, failureFn) {
            getPath({
                path : "organizer/event/" + eventId + "/email-template",
                success : function(jsonData) {
                    successFn && successFn(jsonData["email-template"]);
                },
                failure : failureFn
            });
        };

        var updateEmailTemplate = function(eventId, emailTemplate, successFn, failureFn) {
            putPath({
                path : "organizer/event/" + eventId + "/email-template",
                data : {
                    "email-template" : emailTemplate
                },
                success : function(jsonData) {
                    successFn && successFn(jsonData["email-template"]);
                },
                failure : failureFn
            });
        };

        var getSpeakers = function(query, successFn, failureFn) {
            getPath({
                path : 'organizer/speaker',
                data : {
                    "name" : query
                },
                success : function(jsonData) {
                    _.isFunction(successFn) && successFn(jsonData['search-results'].speaker);
                },
                failure : failureFn
            });
        };

        var isAdmin = function(successFn, failureFn) {
            getPath({
                path : 'admin/isadmin',
                success : successFn,
                failure : failureFn
            });
        };

        var getAccount = function(accountId, successFn, failureFn) {
            getPath({
                path : 'accounts/' + accountId,
                success : successFn,
                failure : failureFn
            });
        };

        var pickToken = function(uniqueName, eventId) {
            return axios.post(
                CONFIG.DASHBOARD_URL +
                    '/auth/transfer/pick?uniqueName=' +
                    uniqueName +
                    '&eventId=' +
                    eventId,
                null,
                {
                    withCredentials: true
                }
            ).then(function (res) {
                if(res.data && res.data.token) {
                    return res.data.token;
                } else {
                    throw new Error('Cannot get token');
                }
            });
        };

        var dropToken = function (token, eventUrl) {
            return axios.post(
                eventUrl + '/auth/transfer/drop',
                {
                    token: token,
                    preview: true
                },
                {
                    withCredentials: true
                }
            )
        };

        var authenticateOnEventWebsite = function (uniqueName, eventId, eventUrl) {
            return pickToken(uniqueName, eventId)
                .then(function (token) {
                    return dropToken(token, eventUrl);
                });
        };

        // Public object ----------------------------------------

        return {
            errorCodes : errorCodes,
            hasToken : hasToken,
            token : bzToken,
            signIn : signIn,
            signUp : signUp,
            signOut : signOut,
            getPerson : getPerson,
            updatePerson : updatePerson,
            updateToken : updateToken,
            getEventDetails : getEventDetails,
            getMyCreatedEvents : getMyCreatedEvents,
            importEvents : importEvents,
            createEvent : createEvent,
            updateEventDetails : updateEventDetails,
            getEmailList : getEmailList,
            updateEmailList : updateEmailList,
            sendInviteMailToList : sendInviteMailToList,
            sendTestInviteMail : sendTestInviteMail,
            scheduleInviteMailToList : scheduleInviteMailToList,
            getInviteMailPreview : getInviteMailPreview,
            publishEvent : publishEvent,
            getAgenda : getAgenda,
            updateAgenda : updateAgenda,
            sendMessageToRSVP : sendMessageToRSVP,
            getSocialShareAnalytics : getSocialShareAnalytics,
            getSocialShareImpressions : getSocialShareImpressions,
            getRsvpList : getRsvpList,
            buildCommunity : buildCommunity,
            removeCommunity : removeCommunity,
            getPartnersList : getPartnersList,
            updatePartnersList : updatePartnersList,
            getServicePlan : getServicePlan,
            getFreeServicePlan : getFreeServicePlan,
            getServicePlanByEventID: getServicePlanByEventID,
            updateServicePlan : updateServicePlan,
            getPartnersAnalytics : getPartnersAnalytics,
            replaceImageURL : replaceImageURL,
            getEventAnalytics : getEventAnalytics,
            getTopEntities : getTopEntities,
            checkUniqueName: checkUniqueName,
            enablePollingRegistrationSystem: enablePollingRegistrationSystem,
            disablePollingRegistrationSystem: disablePollingRegistrationSystem,
            getEmailTemplate : getEmailTemplate,
            updateEmailTemplate : updateEmailTemplate,
            deletePersonInEvent: deletePersonInEvent,
            getSpeakers: getSpeakers,
            isAdmin: isAdmin,
            getAccount: getAccount,
            getPollsList: getPollsList,
            updatePollsList: updatePollsList,
            createPoll: createPoll,
            updatePoll: updatePoll,
            clearPollResults: clearPollResults,
            deletePoll: deletePoll,
            updatePollsOrder: updatePollsOrder,
            authenticateOnEventWebsite: authenticateOnEventWebsite,
            getTokenFromHeaders: getTokenFromHeaders,
            setBzToken: setBzToken,
            getRootDomain: getRootDomain
        };
    })();

    return BZAPI;

});

